// Settings
import settings from 'settings'

// Utils
import { api } from 'app/views/utils/api'
import { getTeamDetails } from './hacker'


const LRS_SET_INFO = 'LRS_SET_INFO'
const LRS_SET_ACTIVATE_LRS = 'LRS_SET_ACTIVATE_LRS'
const LRS_SET_LOADING = 'LRS_SET_LOADING'
const LRS_SET_REDUCER = 'LRS_SET_REDUCER'


const initialState = {
  endpoint: '',
  key: '',
  secret: '',
  active: false,
  isLoading: false,
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LRS_SET_REDUCER:
      return {
        ...state,
        [action.payload.key]: action.payload.value,
      }
    case LRS_SET_LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
      }
    case LRS_SET_INFO:
      return {
        ...state,
        endpoint: action.endpoint,
        key: action.key,
        secret: action.secret,
        active: action.active,
      }
    case LRS_SET_ACTIVATE_LRS:
      return {
        ...state,
        active: action.activated,
      }
    default:
      return state
  }
}

export function setLrsReducer(payload) {
  return {
    type: LRS_SET_REDUCER,
    payload,
  }
}

export function triggerLrsIntegration(activated, errorCallback = false) {
  return (dispatch, getState) => {
    dispatch({
      type: LRS_SET_LOADING,
      isLoading: true,
    })
    const state = getState()
    const { lrs } = state
    const {
      endpoint,
      key,
      secret,
    } = lrs
    const newEndpoint = endpoint.length > 0 ? endpoint.replace(/\/?$/, '/') : null

    if (activated === true && newEndpoint !== null && !newEndpoint.startsWith('https://')) {
      if (errorCallback !== false) {
        errorCallback()
      }
      dispatch({
        type: LRS_SET_LOADING,
        isLoading: false,
      })
      return false
    }

    return api({
      method: 'post',
      url: `${settings.urls.hacker}/organizations/${state.hacker.currentTeamDetails.uuid}/lrs`,
      idToken: state.auth.user.idToken,
      data: {
        active: activated,
        endpoint: newEndpoint,
        key: key || null,
        secret: secret || null,
      },
    })
      .then(({ data }) => {
        dispatch({
          type: LRS_SET_ACTIVATE_LRS,
          activated,
        })
        dispatch(getTeamDetails(state.hacker.currentTeamDetails.uuid, data.valid_connection))
        if (!data.valid_connection) {
          if (errorCallback) {
            errorCallback()
          }
        }
        dispatch({
          type: LRS_SET_LOADING,
          isLoading: false,
        })
      })
      .catch(() => {
        dispatch({
          type: LRS_SET_LOADING,
          isLoading: false,
        })
      })
  }
}
